<template>
  <div class="queue-input">
    <span class="queue-input__label">{{ label }}</span>
    <input
      class="queue-input__field"
      :type="type"
      :placeholder="placeholder"
      :value="modelValue"
      @input="$emit('update:modelValue', $event.target.value)"
    >
  </div>
</template>

<script>
export default {
  name: 'QueueInput',
  props: {
    label: {
      type: String,
      default: ''
    },
    modelValue: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  emits: ['update:modelValue']
}
</script>

<style scoped>
.queue-input {
  position: relative;
  display: inline-block;
  width: 280px;
}

.queue-input__label {
  position: absolute;
  top: 0;
  left: 16px;
  transform: translateY(-50%);
  padding: 0 6px;
  background: #fff;
  color: #3b82f6;
  font-size: 0.85rem;
  font-weight: 600;
}

.queue-input__field {
  width: 100%;
  box-sizing: border-box;
  padding: 16px 14px;
  border: 2px solid #3b82f6;
  border-radius: 12px;
  font-size: 1rem;
  font-weight: bold;
  color: #111827;
  outline: none;
}

.queue-input__field::placeholder {
  font-weight: normal;
  color: #9ca3af;
}

.queue-input__field:focus {
  border-color: #2563eb;
}
</style>
